import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { CREW_MATERIALS_ACTIONS } from "../../../../redux/crewMaterials/actions";
import {
  selectCrewMaterials,
  crewMaterialCreating,
  crewMaterialsLoaded,
  crewMaterialsMeta
} from "../../../../redux/crewMaterials/selectors";
import MaterialTemplateForm from "../../../forms/MaterialTemplateForm";
import Confirm from "../../../../base/Confirm";
import ListView from "../../../../base/ListView";
import { NavLink } from "react-router-dom";
import { CREW_MATERIAL_TEMPLATES_ACTIONS } from "../../../../redux/crewMaterialTemplates/actions";
import {
  crewMaterialTemplateCreating,
  crewMaterialTemplateFilters,
  crewMaterialTemplateMeta,
  crewMaterialTemplateUpdating,
  selectActiveCrewMaterialTemplate,
  selectCrewMaterialTemplates
} from "../../../../redux/crewMaterialTemplates/selectors";

class _CrewMaterials extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      crewMaterials: this.props.crewMaterials,
      crewMaterialsLoaded: this.props.crewMaterialsLoaded,
      baseFilters: {
        "page[number]": 1,
        "page[size]": 10,
        sort: "-updated_at"
      },
      newMaterial: "",
      activeMaterial: 0
    };

    this._handleCreate = this._handleCreate.bind(this);
    this._handleDelete = this._handleDelete.bind(this);
    this._handleFilterUpdate = this._handleFilterUpdate.bind(this);
    this._handleMaterialChange = this._handleMaterialChange.bind(this);
    this._addNewMaterial = this._addNewMaterial.bind(this);
    this._deleteMaterial = this._deleteMaterial.bind(this);
  }

  static propTypes = {
    crewMaterials: PropTypes.array,
    crewMaterialsLoaded: PropTypes.bool,
    match: PropTypes.object,
    createCrewMaterial: PropTypes.func,
    updateCrewMaterial: PropTypes.func,
    deleteCrewMaterial: PropTypes.func,
    crewMaterialTemplateCreating: PropTypes.bool,
    crewMaterialsMeta: PropTypes.object,
    filters: PropTypes.object,
    updateFilters: PropTypes.func,
    event: PropTypes.object,
    activeMaterialTemplate: PropTypes.object,
    resetActive: PropTypes.func,
    loadCrewMaterialTemplates: PropTypes.func,
    loadCrewMaterialTemplate: PropTypes.func,
    crewMaterialTemplates: PropTypes.array,
    crewMaterialTemplatesMeta: PropTypes.object,
    createCrewMaterialTemplate: PropTypes.func,
    updateCrewMaterialTemplate: PropTypes.func,
    deleteTemplate: PropTypes.func,
    loadMaterials: PropTypes.func
  };

  UNSAFE_componentWillMount() {
    const { materialId, templateId } = this.props.match.params;
    const eventId = this.props.event.id;

    this.props.loadMaterials(this.state.baseFilters, eventId);
    this.setState({ activeMaterial: 0 });

    if (materialId) {
      this.props.loadCrewMaterialTemplates(materialId, eventId);
      this.setState({ activeMaterial: materialId });
    }

    if (templateId) {
      //eventId, crewMaterialId, id
      this.props.loadCrewMaterialTemplate(eventId, materialId, templateId);
    }
  }

  _handleFilterUpdate(filters) {
    this.props.loadMaterials(filters, this.props.event.id);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { materialId, templateId } = nextProps.match.params;

    if (this.props.match.params.materialId !== materialId) {
      this.props.loadCrewMaterialTemplates(materialId, this.props.event.id);
      this.setState({ activeMaterial: materialId });
    } else if (
      this.props.crewMaterials !== nextProps.crewMaterials &&
      nextProps.crewMaterials.length > 0
    ) {
      //history.push('/admin/events/' + this.props.event.id + '/crew-material-requests/' + nextProps.crewMaterials[0].id);
    }

    if (this.props.match.params.templateId !== templateId) {
      this.props.loadCrewMaterialTemplate(
        this.props.event.id,
        materialId,
        templateId
      );
    }
  }

  _handleCreate(values) {
    const data = {
      name: values.name,
      limits: [
        values.limits_1d,
        values.limits_2d,
        values.limits_3d,
        values.limits_4d,
        values.limits_5d,
        values.limits_6d,
        values.limits_7d,
        values.limits_8d
      ]
    };

    if (values.id && values.id !== "") {
      //eventId, crewMemberMaterialId, crewMemberMaterialTemplateId, values
      this.props.updateCrewMaterialTemplate(
        this.props.event.id,
        this.state.activeMaterial,
        values.id,
        data
      );
    } else {
      this.props.createCrewMaterialTemplate(
        this.state.activeMaterial,
        data,
        this.props.event.id
      );
    }
  }

  _handleDelete(id) {
    Confirm(
      "Are you sure you want to delete this Template? This action can not be undone, please make sure no festival is using this template.",
      {
        title: "Delete Material Template",
        confirmStyle: "btn-danger",
        confirmText: "Delete"
      }
    ).then(
      result => {
        //materialId, id, eventId
        this.props.deleteTemplate(
          this.state.activeMaterial,
          id,
          this.props.event.id
        );
      },
      result => {}
    );
  }

  _handleMaterialChange(e) {
    this.setState({
      newMaterial: e.target.value
    });
  }

  _addNewMaterial(e) {
    this.props.createCrewMaterial(
      {
        name: this.state.newMaterial
      },
      this.props.event.id
    );
  }

  _deleteMaterial(material) {
    Confirm(
      "Are you sure you want to delete this Material? This action can not be undone, please make sure no festival is using this material.",
      {
        title: "Delete Material",
        confirmStyle: "btn-danger",
        confirmText: "Delete"
      }
    ).then(
      result => {
        this.props.deleteCrewMaterial(material.id, this.props.event.id);
      },
      result => {}
    );
  }

  render() {
    const {
      filters,
      crewMaterialTemplateCreating,
      event,
      crewMaterials,
      activeMaterialTemplate,
      crewMaterialTemplates,
      crewMaterialTemplatesMeta
    } = this.props;

    const { newMaterial, activeMaterial } = this.state;

    const listViewConf = {
      dataSet: crewMaterialTemplates,
      dataMeta: crewMaterialTemplatesMeta,
      columns: [
        {
          key: "name",
          value: "Name",
          sort: "name"
        },
        {
          key: "limits",
          value: "Limits",
          render: item =>
            item.crewMemberMaterialTemplateLimits
              .map(item => item.amount)
              .join(" - ")
        }
      ],
      baseFilters: filters,
      filters: [
        {
          label: "Name",
          icon: "la-search",
          type: "text",
          key: "name"
        }
      ],
      actions: {
        deleteLink: true,
        editLink: true,
        detailsLink: false,

        deleteFunction: this._handleDelete
      },
      url:
        "/admin/events/" +
        event.id +
        "/crew-materials/" +
        activeMaterial +
        "/template"
    };

    return (
      <div>
        <div className="row" key="header">
          <div className="col-xl-12">
            <div className="m-portlet  m-portlet--tabs">
              <div className="m-portlet__head">
                <div className="m-portlet__head-tools">
                  <ul
                    className="nav nav-tabs m-tabs m-tabs-line   m-tabs-line--left m-tabs-line-danger"
                    role="tablist"
                  >
                    {crewMaterials.map(material => (
                      <li
                        className="nav-item m-tabs__item"
                        key={"material_" + material.id}
                      >
                        <NavLink
                          className="nav-link m-tabs__link"
                          to={
                            "/admin/events/" +
                            event.id +
                            "/crew-materials/" +
                            material.id
                          }
                        >
                          {material.name}{" "}
                          <span
                            className="m-badge m-badge--danger active-only"
                            onClick={() => this._deleteMaterial(material)}
                          >
                            x
                          </span>
                        </NavLink>
                      </li>
                    ))}
                  </ul>
                  <ul className="m-portlet__nav m--margin-left-20">
                    <li className="m-portlet__nav-item access">
                      <input
                        type="text"
                        className="form-control m-input"
                        value={newMaterial}
                        onChange={this._handleMaterialChange}
                        placeholder="Create Material"
                      />
                    </li>
                    <li className="m-portlet__nav-item">
                      <button
                        type="submit"
                        className="m-portlet__nav-link btn btn-brand m-btn m-btn--icon m-btn--icon-only"
                        disabled={!newMaterial}
                        onClick={this._addNewMaterial}
                      >
                        <i className="la la-plus" />
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        {activeMaterial !== 0 && (
          <div className="row" key="content">
            <div className="col-xl-8">
              <ListView
                config={listViewConf}
                handleDelete={this._handleDelete}
                handleFilterUpdate={this._handleFilterUpdate}
              />
            </div>
            <div className="col-xl-4">
              <div className="m-portlet">
                <div className="m-portlet__head">
                  <div className="m-portlet__head-caption">
                    <div className="m-portlet__head-title">
                      <span className="m-portlet__head-icon">
                        <i className="flaticon-map-location" />
                      </span>
                      <h3 className="m-portlet__head-text">
                        {activeMaterialTemplate
                          ? "Edit Template"
                          : "Create Template"}
                      </h3>
                    </div>
                  </div>
                </div>
                <MaterialTemplateForm
                  onSubmit={this._handleCreate}
                  isCreating={crewMaterialTemplateCreating}
                  materialTemplate={activeMaterialTemplate}
                  event={event}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  resetActive: () => dispatch(CREW_MATERIALS_ACTIONS.resetActive()),
  loadCrewMaterialTemplates: (materialId, eventId) =>
    dispatch(
      CREW_MATERIAL_TEMPLATES_ACTIONS.loadAllRequest(materialId, eventId)
    ),
  loadCrewMaterialTemplate: (eventId, crewMaterialId, id) =>
    dispatch(
      CREW_MATERIAL_TEMPLATES_ACTIONS.loadRequest(eventId, crewMaterialId, id)
    ),
  createCrewMaterialTemplate: (id, values, eventId) =>
    dispatch(
      CREW_MATERIAL_TEMPLATES_ACTIONS.createRequest(id, values, eventId)
    ),
  updateCrewMaterialTemplate: (
    eventId,
    crewMemberMaterialId,
    crewMemberMaterialTemplateId,
    values
  ) =>
    dispatch(
      CREW_MATERIAL_TEMPLATES_ACTIONS.updateRequest(
        eventId,
        crewMemberMaterialId,
        crewMemberMaterialTemplateId,
        values
      )
    ),
  createCrewMaterial: (values, eventId) =>
    dispatch(CREW_MATERIALS_ACTIONS.createRequest(values, eventId)),
  updateCrewMaterial: (id, values, eventId) =>
    dispatch(CREW_MATERIALS_ACTIONS.updateRequest(id, values, eventId)),
  deleteCrewMaterial: (id, eventId) =>
    dispatch(CREW_MATERIALS_ACTIONS.deleteRequest(id, eventId)),
  deleteTemplate: (materialId, id, eventId) =>
    dispatch(
      CREW_MATERIAL_TEMPLATES_ACTIONS.deleteRequest(materialId, id, eventId)
    ),
  loadMaterials: (filters, eventId) =>
    dispatch(CREW_MATERIALS_ACTIONS.loadAllRequest(filters, eventId))
});

const mapStateToProps = function(state) {
  return {
    crewMaterials: selectCrewMaterials(state),
    crewMaterialTemplates: selectCrewMaterialTemplates(state),
    crewMaterialsLoaded: crewMaterialsLoaded(state),
    crewMaterialCreating: crewMaterialCreating(state),
    crewMaterialsMeta: crewMaterialsMeta(state),
    crewMaterialTemplatesMeta: crewMaterialTemplateMeta(state),
    filters: crewMaterialTemplateFilters(state),
    activeMaterialTemplate: selectActiveCrewMaterialTemplate(state),
    crewMaterialTemplateCreating: crewMaterialTemplateCreating(state),
    crewMaterialTemplateUpdating: crewMaterialTemplateUpdating(state)
  };
};

const CrewMaterials = connect(
  mapStateToProps,
  mapDispatchToProps
)(_CrewMaterials);

export default CrewMaterials;
